var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { PressableBox } from '../box';
export const Surface = memo((_a) => {
    var { small = false, variant = 'tertiary', style } = _a, rest = __rest(_a, ["small", "variant", "style"]);
    return (_jsx(PressableBox, Object.assign({}, rest, { disabled: rest.disabled || !rest.onPress, style: [$.container, small && $.containerSmall, $[variant], style] })));
});
const $ = StyleSheet.create({
    container: {
        padding: theme.spacing['6'],
        borderRadius: theme.radius.md,
    },
    containerSmall: {
        padding: theme.spacing['4'],
        borderRadius: theme.radius.sm,
    },
    brand: {
        backgroundColor: theme.color.background.brand,
    },
    'brand-light': {
        backgroundColor: theme.color.background['brand-light'],
    },
    primary: {
        backgroundColor: theme.color.background.primary,
    },
    success: {
        backgroundColor: theme.color.background.success,
    },
    secondary: {
        backgroundColor: theme.color.background.secondary,
    },
    warning: {
        backgroundColor: theme.color.background.warning,
    },
    info: {
        backgroundColor: theme.color.background.info,
    },
    tertiary: {
        backgroundColor: theme.color.background.tertiary,
    },
    error: {
        backgroundColor: theme.color.background.error,
    },
    white: {
        backgroundColor: theme.color.background.white,
    },
    transparent: {
        backgroundColor: 'transparent',
    },
});
